import { StudyGroupBuddiesComponent } from './components/study_group_buddies/study_group_buddies_component';
import { StudyGroupJoinComponent } from './components/study_group_join/study_group_join';
import { StudyGroupSectionTileComponent } from './components/study_group_section_tile/study_group_section_tile_component';
import { StudyGroupTermsComponent } from './components/study_group_terms/study_group_terms_component';
import { StudyGroupDescriptionModalComponent } from './modals/study_group_description_modal/study_group_description_modal';
import { StudyGroupEmailingModalComponent } from './modals/study_group_emailing_modal/study_group_emailing_modal';
import { StudyGroupJoiningModalComponent } from './modals/study_group_joining_modal/study_group_joining_modal';
import { StudyGroupModalService } from './modals/study_groups_modal_service';
import { StudyGroupsPriorityFeedQuery } from './queries/study_groups_priority_feed_query';
import { StudyGroupsQuery } from './queries/study_groups_query';
import { StudyGroupsCapabilityConfiguration } from './study_groups_configuration';
import { MyStudyGroupsRoutes } from './study_groups_routes';
import { StudyGroupMembersController } from './views/study_group_members/study_group_members_controller';
import { StudyGroupsController } from './views/study_groups/study_groups_controller';

angular
  .module('capability-ng-study-groups', ['data-ng-custom-text'])
  .service('ngStudyGroupModalService', StudyGroupModalService)
  .component('studyGroupJoiningModal', new StudyGroupJoiningModalComponent())
  .component('studyGroupDescriptionModal', new StudyGroupDescriptionModalComponent())
  .component('studyGroupEmailingModal', new StudyGroupEmailingModalComponent())
  .component('studyGroupTerms', new StudyGroupTermsComponent())
  .component('studyGroupSectionTile', new StudyGroupSectionTileComponent())
  .component('studyGroupBuddies', new StudyGroupBuddiesComponent())
  .component('studyGroupJoin', new StudyGroupJoinComponent())
  .controller('StudyGroupsController', StudyGroupsController)
  .controller('StudyGroupMembersController', StudyGroupMembersController)
  .service('ngStudyGroupsCapabilityConfiguration', StudyGroupsCapabilityConfiguration)
  .service('ngStudyGroupsQuery', StudyGroupsQuery)
  .service('ngStudyGroupsPriorityFeedQuery', StudyGroupsPriorityFeedQuery)
  .config(MyStudyGroupsRoutes);

import './core';

export * from './study_groups_configuration';
export * from './queries/study_groups_priority_feed_query';

export const studyGroups = 'capability-ng-study-groups';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/main.ts